import { ComponentProps, useState } from "react";
import { ToggleButton } from "staysure-component-library";

import withBrand from "@/components/with-brand";

import Styles from "./toggle-btn-wrapper.module.css";

type ToggleButtonProps = ComponentProps<typeof ToggleButton>;

function ToggleBtnLabelWrapper(
  props: ToggleButtonProps &
    Readonly<{
      onBlur?: () => void;
      label: string;
    }>
) {
  const { semanticColor, onClick, className, brand, label, ...others } = props;
  const [isKeyBoardFocused, setIsKeyBoardFocused] = useState(true);

  const handleClick = (e: boolean | React.MouseEvent) => {
    if (onClick !== undefined) {
      onClick(typeof e === "boolean" ? e : true);
    }
  };

  const handleOnPressStart = (e: { pointerType: string }) => {
    if (e.pointerType === "keyboard") {
      setIsKeyBoardFocused(true);
    } else {
      setIsKeyBoardFocused(false);
    }
  };

  const brandClass =
    brand === "staysure" ? Styles.toggle_btn_sts : Styles.toggle_btn_avn;

  return (
    <ToggleButton
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...others}
      btnType="button"
      label={label}
      className={`${brandClass} ${
        isKeyBoardFocused ? "keyBoardFocused" : ""
      } ${className} outline-none`}
      semanticColor={semanticColor}
      onClick={(e) => handleClick(e)}
      onFocusChange={(e) => setIsKeyBoardFocused(e)}
      onPressStart={(e: { pointerType: string }) => handleOnPressStart(e)}
    />
  );
}

export default withBrand(ToggleBtnLabelWrapper);
